export const MIXPANEL_IDLE_TIMEOUT_MILLISECONDS = 60000
export const MIXPANEL_RECORD_SESSIONS_PERCENT = 5.0
